import React from 'react';
import { FiMapPin, FiUser, FiPhone, FiHome } from 'react-icons/fi';
import styles from '../components/bodywon.module.css';

const DeliveryAddressCard = ({ address, title = 'Delivery Address', onEdit, editLabel = 'Edit' }) => {
  if (!address) return null;

  const fullName = address.fullName || '—';
  const mobile = address.mobileNumber || '—';
  const line1 = address.addressLine1?.trim();
  const line2 = address.addressLine2?.trim();
  const landmark = address.landmark?.trim();
  const cityLine = [address.city, address.state, address.postalCode].filter(Boolean).join(', ');
  const country = address.country?.trim();
  const addressType = address.addressType?.trim();

  return (
    <div className={styles.deliveryAddressCard}>
      <div className={styles.deliveryAddressHead}>
        <div className={styles.deliveryAddressHeadTitle}>
          <span className={styles.deliveryAddressHeadIcon} aria-hidden>
            <FiMapPin />
          </span>
          <h2 className={styles.deliveryAddressTitle}>{title}</h2>
        </div>
        {onEdit ? (
          <button type="button" className={styles.deliveryAddressEditLink} onClick={onEdit}>
            {editLabel}
          </button>
        ) : null}
      </div>

      <div className={styles.deliveryAddressBody}>
        <div className={styles.deliveryAddressRow}>
          <span className={styles.deliveryAddressRowIcon}><FiUser /></span>
          <div className={styles.deliveryAddressRowContent}>
            <span className={styles.deliveryAddressLabel}>Full Name</span>
            <span className={styles.deliveryAddressValue}>{fullName}</span>
          </div>
        </div>

        <div className={styles.deliveryAddressRow}>
          <span className={styles.deliveryAddressRowIcon}><FiPhone /></span>
          <div className={styles.deliveryAddressRowContent}>
            <span className={styles.deliveryAddressLabel}>Mobile</span>
            <span className={styles.deliveryAddressValue}>{mobile}</span>
          </div>
        </div>

        <div className={styles.deliveryAddressDivider} />

        <div className={styles.deliveryAddressRow}>
          <span className={styles.deliveryAddressRowIcon}><FiHome /></span>
          <div className={styles.deliveryAddressRowContent}>
            <span className={styles.deliveryAddressLabel}>Address</span>
            <div className={styles.deliveryAddressValueStack}>
              {line1 ? <span>{line1}</span> : null}
              {line2 ? <span>{line2}</span> : null}
              {landmark ? <span className={styles.deliveryAddressLandmark}>Landmark: {landmark}</span> : null}
              {cityLine ? <span>{cityLine}</span> : null}
              {country ? <span className={styles.deliveryAddressCountry}>{country}</span> : null}
            </div>
          </div>
        </div>

        {(addressType || address.isDefault) && (
          <div className={styles.deliveryAddressTags}>
            {addressType ? (
              <span className={styles.deliveryAddressTypeTag}>{addressType}</span>
            ) : null}
            {address.isDefault ? (
              <span className={styles.deliveryAddressDefaultTag}>Default</span>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryAddressCard;
